import { render, staticRenderFns } from "./BusinessPartners.vue?vue&type=template&id=28d97932&"
import script from "./BusinessPartners.vue?vue&type=script&lang=js&"
export * from "./BusinessPartners.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartners.vue?vue&type=style&index=0&id=28d97932&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports